import focusElement from '~/helpers/a11y-helpers';
export default {
  name: 'SkipTo',
  props: {
    text: {
      type: String,
      default: ''
    },
    to: {
      type: String,
      default: ''
    },
    tabindex: {
      type: [Number, null],
      default: null
    }
  },
  methods: {
    skipPressed() {
      focusElement(this.$el.hash);
    }
  }
};